<template>
  <div style="display: grid; grid-template-columns: 400px auto; height: 100vh">
    <div class="bg-smokeDark">
      <v-list>
        <v-list-item
          v-for="t in tickets"
          :key="t.uid"
          @click="ticket = t"
          :color="ticket && ticket.uid === t.uid ? 'primary' : 'white'"
        >
          <div class="d-flex justify-space-between align-center">
            <div>
              <v-list-item-title>{{ t.title }}</v-list-item-title>
              <v-list-item-subtitle>{{ t.description }}</v-list-item-subtitle>
            </div>
            <div>
              <v-chip
                variant="flat"
                :color="
                  t.status === 'open'
                    ? 'primary'
                    : t.status === 'resolved'
                      ? 'success'
                      : 'error'
                "
                >{{ t.status }}</v-chip
              >
            </div>
          </div>
        </v-list-item>
      </v-list>
    </div>
    <div class="pa-4">
      <h1>Admin Support</h1>
      <div v-if="ticket">
        <v-select
          v-model="ticket.status"
          :items="['open', 'closed', 'resolved']"
          label="Status"
          variant="solo"
          flat
          @update:model-value="updateStatus"
          bg-color="smokeDark"
          style="width: 200px"
        ></v-select>
        <div class="mb-4">
          <v-textarea
            v-model="newMessage"
            placeholder="Add a message to the ticket"
            rows="3"
            flat
            bg-color="smokeDark"
            variant="solo"
            class="floating-text-field text-caption"
            density="comfortable"
          >
            <template v-slot:append>
              <v-btn @click="sendMessage" color="primary">Send</v-btn>
            </template>
          </v-textarea>
        </div>

        <v-card
          v-for="m in ticket ? ticket.messages : []"
          :key="m.uid"
          flat
          :style="{
            borderBottom: '3px solid #272727',
            borderLeft: '1px solid #272727',
            borderTop: '1px solid #272727',
            borderRight: '3px solid #272727',
            borderRadius: '8px',
            marginLeft: m.role === 'user' ? '0' : '80px',
          }"
          :class="m.role === 'user' ? 'bg-smokeDark' : 'bg-white'"
          class="mb-3"
        >
          <v-card-title>
            <div class="d-flex justify-space-between align-center">
              <div class="d-flex align-center my-2">
                <v-avatar
                  size="30"
                  color="accent"
                  :style="{
                    borderBottom: '2px solid #272727',
                    borderLeft: '1px solid #272727',
                    borderTop: '1px solid #272727',
                    borderRight: '2px solid #272727',
                  }"
                >
                  <div v-if="m.role === 'user'">
                    <v-img
                      v-if="userProfile && userProfile.avatar"
                      :src="userProfile.avatar"
                      width="30"
                      height="30"
                    ></v-img>
                    <span
                      style="font-weight: 600; font-size: 10pt"
                      v-else-if="userProfile"
                      >{{
                        userProfile.first_name.charAt(0).toUpperCase() +
                        userProfile.last_name.charAt(0).toUpperCase()
                      }}</span
                    >
                  </div>
                  <div v-else>
                    <v-img
                      :src="require('@/assets/employees/max-employee.png')"
                      width="30"
                      height="30"
                    ></v-img>
                  </div>
                </v-avatar>

                <p class="mb-0 ml-2" style="font-size: 10pt; font-weight: 400">
                  {{
                    m.role === "user"
                      ? allUsers.find((u) => u.uid === m.created_by).name
                      : "Max (Founder)"
                  }}
                </p>
              </div>
              <div>
                <v-btn
                  size="small"
                  variant="text"
                  icon="mdi-delete"
                  @click="deleteMessage(m.uid)"
                ></v-btn>
              </div>
            </div>

            <v-divider></v-divider>
            <div class="pa-2" style="font-size: 11pt">
              <p>{{ m.content }}</p>
            </div>
          </v-card-title>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { db } from "@/firebase";
import {
  addDoc,
  collection,
  updateDoc,
  doc,
  deleteDoc,
} from "firebase/firestore";
export default {
  computed: {
    ...mapState({
      tickets: (state) => state.admin.supportTickets,
      allUsers: (state) => state.admin.users,
    }),
  },
  data() {
    return {
      ticket: null,
      newMessage: "",
    };
  },
  methods: {
    async deleteMessage(uid) {
      let r = confirm("Are you sure you want to delete this message?");
      if (!r) return;
      await deleteDoc(
        doc(
          db,
          "users",
          this.ticket.user,
          "tickets",
          this.ticket.uid,
          "messages",
          uid
        )
      );
      this.ticket.messages = this.ticket.messages.filter((m) => m.uid !== uid);
      this.$store.commit("setNotification", {
        show: true,
        text: "Message deleted",
        type: "success",
        icon: "mdi-check-circle",
      });
    },
    async sendMessage() {
      if (this.newMessage.trim() === "") {
        alert("Please enter a message");
        return;
      }

      console.log("sendMessage", this.newMessage);
      const docRef = await addDoc(
        collection(
          db,
          "users",
          this.ticket.user,
          "tickets",
          this.ticket.uid,
          "messages"
        ),
        {
          content: this.newMessage,
          role: "assistant",
          created_at: Math.floor(Date.now() / 1000),
          created_by: "Max (Founder)",
        }
      );

      await updateDoc(docRef, {
        uid: docRef.id,
      });
      this.ticket.messages.unshift({
        uid: docRef.id,
        content: this.newMessage,
        role: "assistant",
        created_at: Math.floor(Date.now() / 1000),
        created_by: "Max (Founder)",
      });
      this.$store.dispatch("fetchAdminSupportTickets");
      this.newMessage = "";
    },
    async updateStatus(newStatus) {
      console.log(newStatus);
      await updateDoc(
        doc(db, "users", this.ticket.user, "tickets", this.ticket.uid),
        {
          status: newStatus,
        }
      );
      this.$store.commit("setNotification", {
        show: true,
        text: "Status updated",
        type: "success",
        icon: "mdi-check-circle",
      });
    },
  },
};
</script>
